import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { VersionChecker } from "@/components/VersionChecker";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ExcelApp from "@/pages/ExcelApp";
import MobielInvoer from "@/pages/MobielInvoer";
import SalesApp from "@/pages/SalesApp";
import ERPApp from "@/pages/ERPApp";
import RosmalenPortal from "@/pages/RosmalenPortal";

function HomeGate() {
  const { user, logout } = useAuth();
  // Sales-gebruikers horen in het CRM. We sturen ze alleen door als ze ook echt CRM-toegang
  // hebben (user.crm); anders ontstond er een oneindige redirect-lus (/ -> /sales -> /),
  // wat zich voordeed als een blijvend "synchroniseren"-scherm. Zonder CRM-recht tonen we
  // een duidelijke melding i.p.v. de productie-app aan een Sales-gebruiker te geven.
  if (user && user.roleBase === "Sales") {
    if (user.crm) return <Navigate to="/sales" replace />;
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 px-6 text-center">
        <div className="max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
          <h1 className="text-xl font-bold text-slate-900">Geen CRM-toegang</h1>
          <p className="mt-2 text-sm text-slate-600">
            Je account ({user.name}) heeft geen toegang tot het Sales CRM. Vraag de beheerder
            om CRM-toegang voor jouw rol in te schakelen (Rechten → CRM).
          </p>
          <button
            data-testid="homegate-no-crm-logout"
            onClick={() => logout()}
            className="mt-6 inline-flex items-center justify-center rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800"
          >
            Uitloggen
          </button>
        </div>
      </div>
    );
  }
  return <ExcelApp />;
}

function MobielGate() {
  const { user } = useAuth();
  // De geïnstalleerde app opent standaard op /mobiel (productie-invoer). Een Sales-account
  // heeft daar geen rechten en zag daardoor "Onvoldoende rechten" + "Opnieuw synchroniseren".
  // We sturen Sales-gebruikers daarom door naar hun CRM. Productie/magazijn/expeditie/kiosk
  // (urenregistratie) blijven gewoon op /mobiel.
  if (user && typeof user === "object" && user.roleBase === "Sales") {
    return <Navigate to="/sales" replace />;
  }
  return <MobielInvoer />;
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/mobiel" element={<ProtectedRoute><MobielGate /></ProtectedRoute>} />
            <Route path="/sales" element={<ProtectedRoute crm><SalesApp /></ProtectedRoute>} />
            <Route path="/erp" element={<ProtectedRoute><ERPApp /></ProtectedRoute>} />
            <Route path="/rosmalen" element={<ProtectedRoute><RosmalenPortal /></ProtectedRoute>} />
            <Route path="*" element={<ProtectedRoute><HomeGate /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors duration={2500} closeButton />
        <VersionChecker />
      </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
